//@import dependencies
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { IconContext } from "react-icons";
import {FacebookShareButton, TwitterShareButton, LinkedinShareButton, EmailShareButton, WhatsappShareButton} from 'react-share'
import {FaFacebookF, FaTwitter, FaLinkedinIn, FaLink, FaWhatsapp} from 'react-icons/fa'
import { MdEmail, MdShare } from "react-icons/md";
//@end

//@import components
import ModalMediaComponent from 'app_components/commons/modalMedia'
import IconComponent from 'app_components/commons/icons'
//@end

// @import hooks
import {useColors} from 'app_hooks/useColors'
// @end

// @INFO Import types
import { IMediaData } from 'app_types/media/media.types'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../contentInterestCardCommon.scss'

// @ADD Component types
interface IContentInterestCardCommonLayoutProps {
  cover: string,
  title: string,
  description: string
  list?: string
  media?: IMediaData
  authors?: Array<string>
  share?: string
}

const ContentInterestCardCommonLayout: React.FC<IContentInterestCardCommonLayoutProps> = (props) => {

  const [colors] = useColors()
  const { t } = useTranslation()
  const [openModal, updateOpenModal] = useState<boolean>(false)
  const [triggerClose, updateTriggerClose] = useState<any>({})

  useEffect(() => {
    updateOpenModal(false)
  },[triggerClose])

  /**
   * @INFO Cerrar el modal
   */
  const handleCloseModal = () => {
    updateTriggerClose({})
  }

  return(
    <div
      className={`content_interest-component ${props.list ? 'list' : ''}`}
      // onClick={props.media ? () => updateOpenModal(true) : undefined}
      style={{ cursor: props.media ? 'pointer' : undefined }}
    >
      {props.media ?
        <ModalMediaComponent
          media={props.media}
          open={openModal}
          showDescription
          showName
          onClose={handleCloseModal}
        />
      :null}
      <div className="content-interest-container">
        <div
          className="content-interest-image"
          style={{backgroundImage: `url(${props.cover})`}}
          onClick={props.media ? () => updateOpenModal(true) : undefined}
          >
          {/* <div className="overlay"></div> */}
          {/* <button className="content-interest-card-share">
            <IconComponent svg="ShareCircle" width="20" color={colors.secondary} />
          </button> */}
          {/* <div className="content-interest-start">{props.title}</div> */}
        </div>
        {props.share && (
          <IconContext.Provider value={{ color: "#8dc8e8", className: "icon" }}>
            <div className="dropdown content-interest-card-share">
              <button className="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <MdShare size="1.3rem"/>
              </button>
              <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <FacebookShareButton url={props.share}>
                  <FaFacebookF size="1.3rem"/>
                </FacebookShareButton>
                <TwitterShareButton url={props.share}>
                  <FaTwitter size="1.3rem"/>
                </TwitterShareButton>
                <LinkedinShareButton url={props.share}>
                  <FaLinkedinIn size="1.3rem"/>
                </LinkedinShareButton>
                <EmailShareButton url={props.share}>
                  <MdEmail size="1.3rem"/>
                </EmailShareButton>
                <WhatsappShareButton url={props.share}>
                  <FaWhatsapp size="1.3rem"/>
                </WhatsappShareButton>
              </div>
            </div>
          </IconContext.Provider>
        )}
      </div>
      <div className="content-interest-card-title">{props.title}</div>
      {/* <div className="content-interest-card-subtitle">{props.description}</div> */}
      {props.authors && Array.isArray(props.authors) && props.authors.length > 0 && (
        <div className="content-interest-card-authors">{t('components.research_card.author')}: {props.authors.join(',')}</div>
      )}
      {/* <div>
        <div className="content-interest-title">{props.title}</div>
        <div className="content-interest-description">
          {props.description}
        </div>
      </div> */}
    </div>
  )
}

export default ContentInterestCardCommonLayout
